import styles from './StudyLevelSelectionBadge.module.scss';
import { LevelPriorityItem } from './StudyLevelSelectionBadge.types';

export const STUDY_LEVEL_PRIORITY_ITEMS: LevelPriorityItem[] = [
  { key: 'UNKNOWN', value: 'non renseigné', className: styles.unknown },
  { key: 'OPTIONAL', value: 'facultatif', className: styles.optional },
  { key: 'MANDATORY', value: 'exigé', className: styles.mandatory },
];
